import { Injectable, inject } from '@angular/core';

import { BaseStore } from '../../core/abstractions/base-store';
import { TableStateModel } from '../../models/table-state.model';
import { RepositoryService } from '../repository.service';
import { RepositoriesConfig } from '../../core/utils/repositories.config';
import { DbContext } from '../../core/utils/db-context';

/**
 * Extends {@link BaseStore} (not `BaseRepository`) for the same reason as
 * {@link UnsyncedChangesRepository}: `BaseRepository` injects this class, so it
 * must stay free of the change-tracking collaborators to avoid an NG0200
 * construction cycle (issue #10). Its writes are never tracked, so the former
 * `skipLocalUpdate = true` toggle is obsolete.
 */
@Injectable({
    providedIn: 'root'
})
export class TableStateRepository extends BaseStore<TableStateModel> {

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const repositoryService = inject(RepositoryService);

        super(repositoryService);

        this.config = RepositoriesConfig.repositories.find(r =>
            r.tableName === DbContext.TablesStates
        );
    }
}
